import { AnalyticsService } from "@soenergy/frontend-library/src/plugins/analytics"
import { runOnceCookieIsAllowed } from "@soenergy/frontend-library/src/services/CookiePreferences"

export default {
  registerUserProperties() {
    runOnceCookieIsAllowed("performance", () => {
      AnalyticsService.markUserTypeAsCustomer()
    })
  },
}
